import { ASSIGNMENT_ACTIONS } from "@/assignments/useAssignmentReducer";

export const handleTitleChange = (title, dispatch) => {
  dispatch({
    type: ASSIGNMENT_ACTIONS.SET_ASSIGNMENT_TITLE,
    payload: title,
  });
};

export const handleScheduledDateChange = (date, dispatch) => {
  dispatch({
    type: ASSIGNMENT_ACTIONS.SET_SCHEDULED_DATE,
    payload: date,
  });
};

export const handleInstructionsChange = (instructions, dispatch) =>
  dispatch({
    type: ASSIGNMENT_ACTIONS.SET_ASSIGNMENT_INSTRUCTIONS,
    payload: instructions,
  });

export const handleProvideConsent = (headerId, dispatch) =>
  dispatch({
    type: ASSIGNMENT_ACTIONS.SET_STUDENT_RESTRICTED_CONSENT,
    payload: headerId,
  });

export const handleRemoveStudentAssignee = (assignee, dispatch) =>
  dispatch({
    type: ASSIGNMENT_ACTIONS.REMOVE_STUDENT_ASSIGNEE,
    payload: assignee.unique_id,
  });

export const handleRemoveClassroomAssignee = (assignee, dispatch) =>
  dispatch({
    type: ASSIGNMENT_ACTIONS.REMOVE_CLASSROOM_ASSIGNEE,
    payload: assignee.unique_id,
  });

export const handleUpdateClassroomAssignees = (assignees = [], dispatch) =>
  dispatch({
    type: ASSIGNMENT_ACTIONS.UPDATE_CLASSROOM_ASSIGNEES,
    payload: assignees,
  });

export const handleUpdateStudentAssignees = (assignees = [], dispatch) =>
  dispatch({
    type: ASSIGNMENT_ACTIONS.UPDATE_STUDENT_ASSIGNEES,
    payload: assignees,
  });

export const handleSetAssignment = (assignment, dispatch) =>
  dispatch({
    type: ASSIGNMENT_ACTIONS.SET_ASSIGNMENT,
    payload: assignment,
  });

export const handleDefaultReadingLevelChange = (
  defaultReadingLevel,
  dispatch,
) =>
  dispatch({
    type: ASSIGNMENT_ACTIONS.SET_DEFAULT_READING_LEVEL,
    payload: defaultReadingLevel,
  });

export const handleReadingLevelLockChange = (isReadingLevelLocked, dispatch) =>
  dispatch({
    type: ASSIGNMENT_ACTIONS.SET_IS_READING_LEVEL_LOCKED,
    payload: isReadingLevelLocked,
  });

export const handleUpdateActivitiesSelection = (
  activityUpdateAction,
  dispatch,
) => {
  dispatch({
    type: ASSIGNMENT_ACTIONS.UPDATE_ACTIVITY_SELECTIONS,
    payload: activityUpdateAction,
  });
};

export const handleHideLanguageSelector = (
  hideLanguageSelectorAction,
  dispatch,
) => {
  dispatch({
    type: ASSIGNMENT_ACTIONS.SET_ASSIGNMENT_CONFIG,
    payload: hideLanguageSelectorAction,
  });
};

export const handleHideLexileLevel = (hideLexileLevelAction, dispatch) => {
  dispatch({
    type: ASSIGNMENT_ACTIONS.SET_ASSIGNMENT_CONFIG,
    payload: hideLexileLevelAction,
  });
};

export const handleHideReadAloud = (hideReadAloudAction, dispatch) => {
  dispatch({
    type: ASSIGNMENT_ACTIONS.SET_ASSIGNMENT_CONFIG,
    payload: hideReadAloudAction,
  });
};

export const handleHideChecksForUnderstanding = (
  hideChecksForUnderstanding,
  dispatch,
) => {
  dispatch({
    type: ASSIGNMENT_ACTIONS.SET_ASSIGNMENT_CONFIG,
    payload: hideChecksForUnderstanding,
  });
};

export const handleHideGuidedHighlighting = (
  hideGuidedHighlighting,
  dispatch,
) => {
  dispatch({
    type: ASSIGNMENT_ACTIONS.SET_ASSIGNMENT_CONFIG,
    payload: hideGuidedHighlighting,
  });
};

export const handleHideQuizReveal = (hideQuizRevealAction, dispatch) => {
  dispatch({
    type: ASSIGNMENT_ACTIONS.SET_ASSIGNMENT_CONFIG,
    payload: hideQuizRevealAction,
  });
};

export const handleDisableVocabularySupport = (
  disableVocabularySupportAction,
  dispatch,
) => {
  dispatch({
    type: ASSIGNMENT_ACTIONS.SET_ASSIGNMENT_CONFIG,
    payload: disableVocabularySupportAction,
  });
};

export const verifyAssigneeSelection = (assignment, dispatch) => {
  dispatch({
    type: ASSIGNMENT_ACTIONS.SET_ASSIGNEE_ERROR,
    payload: assignment,
  });
};

export const handleHasUnsavedChanges = (hasUnsavedChangesAction, dispatch) => {
  dispatch({
    type: ASSIGNMENT_ACTIONS.SET_HAS_UNSAVED_CHANGES,
    payload: hasUnsavedChangesAction,
  });
};

export const handleActivityElementSelections = (
  activityElementSelections,
  dispatch,
) => {
  dispatch({
    type: ASSIGNMENT_ACTIONS.SET_ACTIVITY_ELEMENT_SELECTIONS,
    payload: activityElementSelections,
  });
};

export const handleRemoveActivityElementSelections = (dispatch) => {
  dispatch({
    type: ASSIGNMENT_ACTIONS.REMOVE_ACTIVITY_ELEMENT_SELECTIONS,
  });
};

export const handleAssignmentDelete = (dispatch) => {
  dispatch({
    type: ASSIGNMENT_ACTIONS.RESET_ASSIGNMENT,
  });
};

export const setAssignmentMember = (headerId, dispatch) => {
  dispatch({
    type: ASSIGNMENT_ACTIONS.SET_ASSIGNMENT_MEMBER,
    payload: headerId,
  });
};

export const handleHideTranslation = (hideTranslationAction, dispatch) => {
  dispatch({
    type: ASSIGNMENT_ACTIONS.SET_ASSIGNMENT_CONFIG,
    payload: hideTranslationAction,
  });
};
